import * as React from 'react';
import axios from 'axios';
import { getUserId, sessionExpire } from './MonCompteAction';
import { renderAlert } from './RenderCommon';
import {getHostApi, getRequestConfig} from '../../utils';
import {BounceLoader} from "./BounceLoader";

interface RenderDimensionsFieldsState {
  originDimensions: any;
  currentDimensions: any;
  dimensionsMin: any;
  dimensionsMax: any;
  orientation: string | null;

  textAlert: string;
  showAlert: boolean;
  showDimensions: boolean;
  classAlert: string;

  displayChargement: boolean;

  ratio: number;
  disabledBtnSubmitDim: boolean;

  dpiQuality?: string;
}

export default class RenderDimensionsFields
  extends React.Component<any, RenderDimensionsFieldsState> {

  readonly dimensionStep: number = 0.1;
  readonly precision: number = this.props.canCustomDimensionsBatAuto ? 2 : 1;

  isDpiQualityebouncing: boolean = false;

  constructor(props: any) {
    super(props);
    this.state = {
      textAlert: '',
      showAlert: false,
      showDimensions: true,
      classAlert: '',

      displayChargement: false,
      disabledBtnSubmitDim: false,

      originDimensions: null,
      currentDimensions: null,
      dimensionsMin: null,
      dimensionsMax: null,
      orientation: null,
      ratio: 0,
    };
  }

  componentDidMount(): void {
    if (this.props.canCustomDimensionsBatAuto) {
      this._getDimensions();
    }
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<RenderDimensionsFieldsState>, snapshot?: any) {
    if((prevProps.surfaceEmplacementId != this.props.surfaceEmplacementId) || (prevProps.dimensions != this.props.dimensions)) {
      this._getDimensions();
    }
  }

  _displayChargement = (display: boolean) => {
    this.setState({
      displayChargement: display,
    });
  }

  _alertMustBeDisplayed = () => {
    return this.state.textAlert !== '' && this.state.showAlert;
  }


  _infoDimensions = (type: string, cm: number) => {
    let hasAlert = false;
    const idLine = this.props.identifier;
    const elements = document.getElementById(idLine)?.querySelectorAll('.infoDim');
    cm =  Number((Math.floor(cm * 100) / 100).toFixed(2));
    Array.from(elements || []).forEach((element) => {
      element.classList.add('d-none');
    });
    if ((type == 'largeur' && cm < this._getFormattedMinDimensions().largeur)
      || (type == 'hauteur' && cm < this._getFormattedMinDimensions().hauteur)) {
      document.getElementById(idLine)?.querySelector('.min' + type)?.classList.remove('d-none');
      hasAlert = true;
    }
    else if ((type == 'largeur' && cm > this._getFormattedMaxDimensions().largeur)
      || (type == 'hauteur' && cm > this._getFormattedMaxDimensions().hauteur)) {
      document.getElementById(idLine)?.querySelector('.max' + type)?.classList.remove('d-none');
      hasAlert = true;
    }
    else if ((type == 'largeur' && cm > this._getFormattedMaxInitialeDimensions().largeur)
      || (type == 'hauteur' && cm > this._getFormattedMaxInitialeDimensions().hauteur )) {
      document.getElementById(idLine)?.querySelector('.supInitiale' + type)?.classList.remove('d-none');
    }
    return  hasAlert ;
  }

  _updateFromLargeurField = (event: React.ChangeEvent<HTMLInputElement>) => {
    this._hideAlert();
    const largeur = event.target.value;
    if (largeur) {
      const hauteur = this.state.orientation !== 'paysage' ?  Number((Number(largeur) * Number(this.state.ratio))) : Number((Number(largeur) / Number(this.state.ratio)));
      const hauteurRound =  Number((Math.floor(hauteur * 100) / 100).toFixed(2));
        this.setState({
          currentDimensions: {
            largeur: Number(largeur),
            hauteur: Number(hauteurRound)
          },
          disabledBtnSubmitDim: this._infoDimensions('largeur', Number(largeur)) || Number(this.props.dimensions.surface.largeur) === Number(largeur)
        });
    }
  }

  _updateFromHauteurField = (event: React.ChangeEvent<HTMLInputElement>) => {
    this._hideAlert();
    const hauteur = event.target.value;
    if (hauteur) {
      const largeur = this.state.orientation !== 'paysage' ?  Number((Number(hauteur) / Number(this.state.ratio))) : Number((Number(hauteur) * Number(this.state.ratio)));
      const largeurRound =  Number((Math.floor(largeur * 100) / 100).toFixed(2));
          this.setState({
             currentDimensions: {
          largeur: Number(largeurRound),
          hauteur: Number(hauteur),
        },
        disabledBtnSubmitDim: this._infoDimensions('hauteur',Number(hauteur)) ||  Number(this.props.dimensions.surface.hauteur) === Number(hauteur)
      });
    }
  }

  _updateDpiQuality = () => {
    if (this.isDpiQualityebouncing) {
      return;
    }
    this.isDpiQualityebouncing = true;
    setTimeout(() => {
      this._getDpiQuality();
      this.isDpiQualityebouncing = false;
    }, 1000);
  }

  _checkLargeurFields = (event: React.ChangeEvent<HTMLInputElement>) => {
    const largeur = Number(event.target.value);
    if (largeur < this._getFormattedMinDimensions().largeur
      || largeur > this._getFormattedMaxDimensions().largeur) {
      this._resetDimensions();
    }
  }

  _checkHauteurFields = (event: React.ChangeEvent<HTMLInputElement>) => {
    const hauteur = Number(event.target.value);
    if (hauteur < this._getFormattedMinDimensions().hauteur
      || hauteur > this._getFormattedMaxDimensions().hauteur) {
      this._resetDimensions();
    }
  }

  _hideAlert = () => {
    this.setState({
      showAlert: false,
      textAlert: '',
    });
  }

  _displayAlert = (message: string, type: string = 'danger', className?: string) => {
    this.setState({
      showAlert: true,
      textAlert: message,
      classAlert: `alert-${type} ${className}`,
    });
  }

  _resetDimensions = () => {
    this.setState({
      currentDimensions: this.state.originDimensions,
      disabledBtnSubmitDim: true
    });
    this._hideAlert();
  }

  _showDimensions  = (event: React.MouseEvent<Element, MouseEvent>, show : boolean = true) => {
    this._hideAlert();
    if (!show) {
      this.setState({
        showDimensions: true,
      });
    } else {
      this.setState({
        showDimensions: true,
      });
    }
  }

  _putUrlDimensions = () => {
    return getHostApi() + '/customers/' + getUserId() + '/orders/' + this.props.order.idCommande + '/items/' +
      this.props.idCaddies + '/surfaces/' + this.props.surface.id + '/locations/' + this.props.emplacement.id +
      '/dimensions-surface';
  }

  _getDimensions = () => {
      if (this.props.dimensions) {
        const dimensions = this.props.dimensions;
        this.setState({
          currentDimensions: dimensions.surface,
          originDimensions: dimensions.surface_origin,
          dimensionsMin: dimensions.surface_min,
          dimensionsMax: dimensions.surface_max,
          orientation: dimensions.orientation,
          ratio: dimensions.ratio,
        });
      }
  }

  _getDpiQuality = () => {
    axios.post(`${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/dpi-quality`,
      {
        dimensions: this.state.currentDimensions,
        orignalFilename: this.props.originalFilename,
        surfaceId: this.props.surface.id,
      },
      getRequestConfig()).then((response) => {
        if (response.data) {
          this.setState({
            dpiQuality: response.data.dpiQuality,
          }, () => {
           // this.props.updateDpiQuality('updateDpiQuality', this.state.dpiQuality);
          });
        }
      }).catch((error) => {
        if (error.response.status === 401) { sessionExpire(); }
      });
  }

  _submitDimensions = () => {
    if (this._infoDimensions('largeur', this.state.currentDimensions.largeur) || this._infoDimensions('hauteur', this.state.currentDimensions.hauteur)) {
       this._displayAlert('Les dimensions saisies dépassent ou sont inférieures aux valeurs autorisées', 'danger', 'retourDimensions');
    } else {
      this._hideAlert();
      this._displayChargement(true);
      if (this.props.canCustomDimensionsBatAuto) {
        this.props.updateDimensions(this.state.currentDimensions);
      } else {
        const url = this._putUrlDimensions();
        axios.post(url, {
          dimensions: this.state.currentDimensions,
          orientation: this.state.orientation,
          pictogramme: this.props.pictogramme.nom,
        }, getRequestConfig()).then((response) => {
          this._displayChargement(false);
          if (response.data.success === true) {
            this.props.getPreview(this.props.idCaddies, true);
            this._getDimensions();
          } else {
            this._resetDimensions();
          }
          if (response.data.message) {
            this.setState({
              showDimensions: true,
            });
            this._displayAlert(response.data.message, 'success', 'retourDimensions');
          }
        }).catch((error) => {
          this._displayChargement(false);
          if (error.response && error.response.data.message) {
            this._displayAlert(error.response.data.message, 'danger', 'retourDimensions');
          }
          this._resetDimensions();
        });
      }
    }
  }

  _getFormattedCurrentDimensions = (): any => {
    return {
      largeur: Number(this.state.currentDimensions.largeur.toFixed(this.precision)),
      hauteur: Number(this.state.currentDimensions.hauteur.toFixed(this.precision)),
    };
  }

  _getFormattedMinDimensions = (): any => {
    const power = Math.pow(10, this.precision);
    return {
      largeur: Math.floor(Number(this.state.dimensionsMin.largeur) * power) / power,
      hauteur: Math.floor(Number(this.state.dimensionsMin.hauteur) * power) / power,
    };
  }

  _getFormattedMaxDimensions = (): any => {
    return {
      largeur: Number(this.state.dimensionsMax.largeur.toFixed(this.precision)),
      hauteur: Number(this.state.dimensionsMax.hauteur.toFixed(this.precision)),
    };
  }

  _getFormattedMaxInitialeDimensions = (): any => {
    return {
      largeur: Number(this.state.originDimensions.largeur.toFixed(this.precision)),
      hauteur: Number(this.state.originDimensions.hauteur.toFixed(this.precision)),
    };
  }

  render() {
    const renderAvertissement = () => {
      if (!this._alertMustBeDisplayed()) {
        return null;
      }
      return (
        <div className="align-self-end  text-center">
          {renderAlert(this.state.showAlert, this.state.classAlert + ' infoDim ', this.state.textAlert)}
        </div>
      );
    };

    const renderFields = () => {
      if (!this.state.currentDimensions || !this.state.dimensionsMax || this.state.displayChargement) {
        return null;
      }

      const titleSubmit = () => {
        if(this.state.currentDimensions === this.state.originDimensions) {
          return 'Aucun changement de dimensions n\'a été détecté';
        }
        return this.state.disabledBtnSubmitDim ? ` Les dimensions saisies dépassent ou sont inférieures aux valeurs autorisées ` : 'Valider';
      }

      return (
        <div className="">
          {!this.state.showDimensions ? (
          <div>
            <div>
              <div className="bold pa02 pb-1 font10" >Dimensions du marquage :</div>
                {this._getFormattedCurrentDimensions().largeur.toString()}cm
                x {this._getFormattedCurrentDimensions().hauteur.toString()}cm
                <button className="ml-2 myButton pa02 p-1 bg-transparent cursor-pointer border border-dark px-2"
                        title="Modifier à la baisse mes dimensions de marquage"
                        onClick={this._showDimensions}>
                  Modifier
                </button>
              </div>
            </div>
          ) : (
          <div className="position-relative" style={{maxWidth: '280px'}}>
            <div className="d-flex align-items-center mx-2">
              <input className="form-control font14 w60px text-center"
                     id={"largeurInput"}
                     type="number" title="Largeur en cm"
                     min={this._getFormattedMinDimensions().largeur.toString()}
                     max={this._getFormattedMaxDimensions().largeur.toString()}
                     step={this.dimensionStep}
                     value={this._getFormattedCurrentDimensions().largeur.toString()}
                     onBlur={this._checkLargeurFields}
                     onChange={this._updateFromLargeurField} required/>
              <span className="font px-1 mr-2">L </span>
              <input className="form-control font14 w60px text-center"
                     id={"hauteurInput"}
                     type="number" title="Hauteur en cm"
                     min={this._getFormattedMinDimensions().hauteur.toString()}
                     max={this._getFormattedMaxDimensions().hauteur.toString()}
                     step={this.dimensionStep}
                     value={this._getFormattedCurrentDimensions().hauteur.toString()}
                     onChange={this._updateFromHauteurField}
                     onBlur={this._checkHauteurFields}
                     disabled={false} required/>
              <span className="pl-2">H</span>

              <button title={titleSubmit()} disabled={this.state.disabledBtnSubmitDim} id={"btnValidationDimensions"} className={`ml-2 bold  white bg-blue myButton border-0 py-1 px-2 ${this.state.disabledBtnSubmitDim ? ' opac30 cursor-notAllowed  ' : '  '} `}
                      onClick={this._submitDimensions}>Ok</button>
            </div>
            <div className="minlargeur infoDim alert alert-warning d-none">
              Minimum autorisé : {this._getFormattedMinDimensions().largeur.toString()}cm de large et {this._getFormattedMinDimensions().hauteur.toString()}cm de haut
            </div>
            <div className="maxlargeur infoDim alert alert-warning d-none">
              Maximum autorisé : {this._getFormattedMaxDimensions().largeur.toString()}cm de large et {this._getFormattedMaxDimensions().hauteur.toString()}cm de haut
            </div>
            <div className="supInitialelargeur infoDim alert alert-warning d-none">
              Vous dépassez la largeur recommandée de {this._getFormattedMaxInitialeDimensions().largeur.toString()}cm de large.
              Cela peut entrainer un ralentissement de votre commande.
            </div>
            <div className="minhauteur infoDim alert alert-warning d-none">
              Minimum autorisé : {this._getFormattedMinDimensions().hauteur.toString()}cm de haut
            </div>
            <div className="maxhauteur infoDim alert alert-warning d-none">
              Maximum autorisé : {this._getFormattedMaxDimensions().hauteur.toString()}cm de haut
            </div>
            <div hidden className="supInitialehauteur infoDim alert alert-warning d-none">
              Vous dépassez la hauteur recommandée de {this._getFormattedMaxInitialeDimensions().hauteur.toString()}cm de haut
            </div>
            <div className="d-none align-items-end justify-content-between">
              <button onClick={this._resetDimensions}>Annuler</button>
              <button className="ml-2 bold white bg-blue myButton border-0 py-1 px-2"
                      onClick={this._submitDimensions}>Modifier</button>
            </div>
            {renderAvertissement()}
          </div>
          )}
        </div>
      );
    };
    return (
        <div>
          <div className="d-flex align-items-end justify-content-end">
            {renderFields()}
            <BounceLoader loading={this.state.displayChargement} />
          </div>
        </div>
    );
  }
}
